enum PageBlockContentTypes {
  VERTICAL_TILE = 'Vertical Tile',
  SIMPLE_COLUMN = 'Simple Column',
}
export default PageBlockContentTypes;
